'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CustomStyleHooksContext: function() {
        return CustomStyleHooksContext;
    },
    CustomStyleHooksProvider: function() {
        return CustomStyleHooksProvider;
    },
    useCustomStyleHook: function() {
        return useCustomStyleHook;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const CustomStyleHooksContext = _react.createContext(undefined);
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = ()=>{};
const CustomStyleHooksProvider = CustomStyleHooksContext.Provider;
const useCustomStyleHook = (hook)=>{
    var _React_useContext;
    var _React_useContext_hook;
    return (_React_useContext_hook = (_React_useContext = _react.useContext(CustomStyleHooksContext)) === null || _React_useContext === void 0 ? void 0 : _React_useContext[hook]) !== null && _React_useContext_hook !== void 0 ? _React_useContext_hook : noop;
};
